"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var social_groups_api_1 = require("@wix/social-groups-api");
var moment = require("moment");
var Controller_1 = require("../Controller");
var ActivityController = /** @class */ (function (_super) {
    tslib_1.__extends(ActivityController, _super);
    function ActivityController(controllerConfig, groupId) {
        var _this = _super.call(this, controllerConfig, groupId) || this;
        _this.getActivity = function (groupId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var from, newPosts, data, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        from = moment().subtract(30, 'days').toISOString();
                        newPosts = 0;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.getActivities(groupId, {
                                time: { from: from },
                            })];
                    case 2:
                        data = (_a.sent()).data;
                        newPosts = this.getNewPosts(data);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.error('Get group activity: FAIL');
                        return [3 /*break*/, 4];
                    case 4:
                        this.setProps({ activities: { newPosts: newPosts } });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.api = new social_groups_api_1.ActivityApi(_this.getSiteToken(), _this.getApiBaseUrl());
        return _this;
    }
    ActivityController.prototype.setProps = function (props) {
        this.controllerConfig.setProps(props);
    };
    ActivityController.prototype.pageReady = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.setProps({
                    activities: undefined,
                    activityActions: {
                        getActivity: this.getActivity,
                    },
                });
                return [2 /*return*/];
            });
        });
    };
    ActivityController.prototype.getNewPosts = function (activities) {
        try {
            return activities.activityStats[0].stats['wix.feed.activities.PostedInFeed'].total;
        }
        catch (e) {
            return 0;
        }
    };
    return ActivityController;
}(Controller_1.Controller));
exports.ActivityController = ActivityController;
//# sourceMappingURL=ActivityController.js.map